import {post} from "@/utils/request";



export const uploadFile = (data) => {
    return post('/upload/file', data);
}

